module.exports = __webpack_public_path__ + "static/media/29.c0f4b24a.JPG";